<template>
  <div>
    <v-form
      autocomplete="new-password"
      ref="form"
      v-model="valid"
      :lazy-validation="lazy"
    >
      <v-text-field
        v-model="formData.email"
        label="Email"
        name="login"
        type="text"
        :rules="emailRules"
        solo
        rounded
        height="70"
        style="border-radius: 70px"
      />

      <v-text-field
        v-model="formData.password"
        id="password"
        label="Senha"
        name="password"
        type="password"
        :rules="required"
        height="70"
        solo
        rounded
        style="border-radius: 70px"
      />
      <!-- Evitando auto complete -->
      <v-text-field v-show="false" id="password_confirmation" />
    </v-form>
  </div>
</template>

<script>
import validations from "@/mixins/validations";
export default {
  mixins: [validations],
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      valid: true,
      lazy: false
    };
  },
  methods: {
    validateForm() {
      return this.$refs.form.validate();
    }
  }
};
</script>
